module.exports = __webpack_public_path__ + "static/img/satyamev-jayate.a5b1332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/satyamev-jayate.png
// module id = /WaH
// module chunks = 1